import React from 'react'
import Header from './Header'

function Home() {
    return (
        <div>
            Hey this is home
        </div>
    )
}

export default Home
